module.exports = __webpack_public_path__ + "img/Vectorinfoerror.d9e32406.svg";